<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose" hideTitle hideMetadata>
		<component :is="component" v-bind="componentProps" v-on="componentListeners" />
		<template v-slot:input-data>
			<slot name="input-data">
				<ConditionSourceDataInputMenu
					:param="param"
					v-on="dataInputListeners"
					ref="data-input-menu"
					:isConditionDependsOnTable="isConditionDependsOnTable"
				/>
			</slot>
		</template>
	</ParamWrapper>
</template>

<script>
import ConditionSourceDataInputMenu from '../../DataInputMenus/RulesDataInputMenus/ConditionSourceDataInputMenu';
import ParamTypeMixin from '../mixins/ParamTypeMixin';
import ParamTypeExtenderDataInputMenuMixin from '../mixins/ParamTypeExtenderDataInputMenuMixin';
import ThisFlowMixin from '../mixins/ThisFlowMixin';
import TableColumnInput from '../../inputsComponents/TableColumnInput';
import TableColumnDropdownInput from '../../inputsComponents/TableColumnDropdownInput';
import TableColumnExtenderDataInputMenuMixin from '../mixins/TableColumnExtenderDataInputMenuMixin';
import IsTextAreaMixin from '../mixins/ParamPropertiesMixins/IsTextAreaMixin';
export default {
	name: 'ConditionSourceParamType',
	mixins: [ParamTypeMixin, ParamTypeExtenderDataInputMenuMixin, ThisFlowMixin, TableColumnExtenderDataInputMenuMixin, IsTextAreaMixin],
	components: { ConditionSourceDataInputMenu, TableColumnInput, TableColumnDropdownInput },
	props: {
		conditionParamsMap: { type: Object },
		isConditionDependsOnTable: { type: Boolean, default: true },
	},
	methods: {
		onContentUpdate(key) {
			if (key === '/') {
				this.onInputClick();
			} else {
				this.onDataInputMenuClose();
				this.onInputFocus();
			}
		},
	},
	computed: {
		paramsMap() {
			return this.conditionParamsMap;
		},
		component() {
			return this.isDropdownInput ? TableColumnDropdownInput : TableColumnInput;
		},
		componentListeners() {
			const listeners = {
				focus: this.onInputFocus,
				blur: this.onInputBlur,
				input: (val) => (this.localValue = val),
				click: this.onInputClick,
				open: this.onInputClick,
				'content-updated': this.onContentUpdate,
			};

			return listeners;
		},
		componentProps() {
			const CHOOSE_COLUMN_PLACEHOLDER_TEXT = this.isDropdownInput ? 'Choose column' : '';
			const getDefaultPlaceholder = () => (this.acceptsSingularValue ? CHOOSE_COLUMN_PLACEHOLDER_TEXT : '');
			const props = {
				...this.$attrs,
				ref: 'richEditor',
				options: this.items,
				nodeId: this.node.id,
				value: this.localValue,
				readonly: this.readonly,
				isFocused: this.isFocused,
				textAreaMode: this.isTextArea,
				showDataMenu: this.showDataMenu,
				isDropdownOpen: this.showDataMenu,
				inputFieldHint: getDefaultPlaceholder(),
			};
			return props;
		},
	},
	data() {
		return {};
	},
	watch: {
		component: {
			handler() {
				this.$nextTick(() => {
					this.setInputElement(this.$refs['richEditor']?.$el);
				});
			},
			immediate: true,
		},
		curTab: {
			handler(val) {
				if (val) {
					this.$emit('update-condition-tab', val.tab);
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.setReplaceValueOnSelection(true);
	},
};
</script>
<style lang="scss" scoped></style>
